import { useEffect, useState } from "react";
import { Box, Heading, Spinner, Text } from "@chakra-ui/react";
import { collection, query, where, orderBy, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // gastro-abst に接続された db
import Session from "./Session";

// セッションデータの型定義
export type SessionItem = {
  id: string;
  title: string;
  day: string;
  order: number;
};

interface ProgramProps {
  title: string;
  today: string;
  year: string; // 追加
}

export default function Program({ title, today, year }: ProgramProps) {
  const [sessions, setSessions] = useState<SessionItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        // sessions コレクションから day が today と一致するデータを検索
        const q = query(
          collection(db, "sessions"),
          where("day", "==", today),
          where("year", "==", year), 
          orderBy("order"),// 追加。yearとdayの複合条件
        );

        const querySnapshot = await getDocs(q);

        const fetchedSessions: SessionItem[] = [];
        querySnapshot.forEach((doc) => {
          fetchedSessions.push({
            id: doc.id,
            ...(doc.data() as Omit<SessionItem, "id">),
          });
        });

        setSessions(fetchedSessions);
      } catch (error) {
        console.error("Session取得エラー:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSessions();
  }, [today]);

  return (
    <Box p={4} borderRadius="md" mb={4}>
      <Heading
        as="h2"
        size="lg"
        mb={12}
        color="blue.700"
        fontWeight="bold"
        whiteSpace="pre-line"
      >
        {title}
      </Heading>

      {loading ? (
        <Spinner size="sm" color="blue.500" />
      ) : sessions.length > 0 ? (
        sessions.map((session) => (
          <Session
            key={session.id}
            id={session.id}
            title={session.title}
            day={session.day}
            year={year} // Sessionへのリンク生成用に渡す
          />
        ))
      ) : (
        <Text color="gray.500" fontSize="sm">
          該当するセッションはありません。
        </Text>
      )}
    </Box>
  );
}
